import { StrictMode } from 'react'
window.name = "viewgate-dashboard";

import { createRoot } from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { SWRConfig } from 'swr'
import { AuthProvider } from './context/AuthContext'
import { LanguageProvider } from './context/LanguageContext'
import { ToastProvider } from './context/ToastContext'
import { ViewGate } from 'viewgate-wrapper'
import './index.css'
import { fetcher } from './services/api'
import App from './App.jsx'
import * as Sentry from "@sentry/react";

Sentry.init({
  dsn: import.meta.env.VITE_SENTRY_DSN,
  sendDefaultPii: true,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
  ],
  // Performance Monitoring
  tracesSampleRate: 1.0, // Capture 100% of the transactions
  // Session Replay
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  environment: import.meta.env.MODE,
});

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <BrowserRouter future={{ v7_startTransition: true, v7_relativeSplatPath: true }}>
      <LanguageProvider>
        <AuthProvider>
          <ToastProvider>
            <SWRConfig
              value={{
                fetcher,
                revalidateOnFocus: true,
                revalidateOnReconnect: true,
                revalidateIfStale: true,
                dedupingInterval: 5000,
                focusThrottleInterval: 30000,
                keepPreviousData: false,
                errorRetryCount: 3,
                errorRetryInterval: 5000,
                compare: (a, b) => JSON.stringify(a) === JSON.stringify(b)
              }}
            >
              <ViewGate language="es" apiKey="13ce2667c7ba226f98a8a08226fcb956bf3d4213270c2296d136aa996d88f687">
                <App />
              </ViewGate>
            </SWRConfig>
          </ToastProvider>
        </AuthProvider>
      </LanguageProvider>
    </BrowserRouter>
  </StrictMode>,
)
